/**
 * Products content placeholder: resolves SKUs through storefront search, because Liquid
 * cannot look up a product by SKU. Rendered by snippets/mx-content-placeholders.liquid,
 * results come from sections/mx-content-products.liquid.
 */
class ContentProducts extends HTMLElement {
  connectedCallback() {
    if (this.dataset.state) return;
    this.dataset.state = 'loading';
    this.load();
  }

  async load() {
    const skus = this.dataset.skus.split(',').filter(Boolean);
    const query = skus.map((sku) => `variants.sku:${sku}`).join(' OR ');
    const url = `${this.dataset.searchUrl}?q=${encodeURIComponent(query)}&type=product&sections=mx-content-products`;

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const sections = await response.json();
      this.render(sections['mx-content-products'] || '');
    } catch (error) {
      console.warn(`[content-placeholder] products: loading failed (${error.message})`);
      this.remove();
    }
  }

  render(sectionHtml) {
    const result = new DOMParser().parseFromString(sectionHtml, 'text/html').querySelector('.content-products-result');
    const missingSkus = result?.dataset.missingSkus?.split(',').filter(Boolean) || [];
    missingSkus.forEach((sku) => console.warn(`[content-placeholder] products: SKU ${sku} not found`));

    if (result && this.dataset.soldOut !== 'true') {
      result.querySelectorAll('.content-products__item[data-available="false"]').forEach((item) => {
        console.warn(`[content-placeholder] products: SKU ${item.dataset.sku} is sold out, hidden`);
        item.remove();
      });
    }

    if (!result || !result.querySelector('.content-products__item')) {
      this.remove();
      return;
    }

    const sliderId = `slider-${this.id}`;
    result.querySelector('.slider').id = sliderId;
    result.querySelectorAll('[aria-controls]').forEach((control) => control.setAttribute('aria-controls', sliderId));
    this.querySelector('.content-products__skeleton')?.remove();
    this.insertAdjacentHTML('beforeend', result.innerHTML);
    this.dataset.state = 'loaded';
  }
}

if (!customElements.get('content-products')) {
  customElements.define('content-products', ContentProducts);
}
